import React, { Component } from 'react'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import { connect } from 'react-redux';
import { authenticateUser } from './Cognito'
import { userActions } from './_actions';

class Signin extends Component {
  constructor (props) {
    super(props)
    this.changeEmail = this.changeEmail.bind(this)
    this.changePassword = this.changePassword.bind(this)
    this.handleSigninSubmit = this.handleSigninSubmit.bind(this)
    this.handleSignin = this.handleSignin.bind(this)

    this.state = {
      email: '',
      password: '',
      loading: false,
			disabled: true
    }
  }

  changeEmail (e) {
    this.setState({ email: e.target.value.toLowerCase() })
		this.checkDisabled()
  }

  changePassword (e) {
    this.setState({ password: e.target.value })
		this.checkDisabled()
  }

	checkDisabled() {
		if (this.state.email !== '' && this.state.password !== '' && !this.state.loading){
			this.setState({ disabled: false})
		}
		else{
			this.setState({ disabled: true })
		}
	}

  componentDidMount () {
		this.props.dispatch(userActions.getUser());
	}

  handleSigninSubmit (e) {
    e.preventDefault()
    this.setState({ loading: true })
    authenticateUser(this.state.email, this.state.password, (err, result) => {
      if (err) {
        console.log(err)
        this.setState({ loading: false })
        return
      }

      console.log(result)
      this.setState({ loading: false })
      window.location.reload()
    })
  }
	
	handleSignin(e) {
		e.preventDefault();

    this.setState({ loading: true });
    const { email, password } = this.state;
    const { dispatch } = this.props;

    if (email && password) {
        dispatch(userActions.login(email, password));
    }
  }

  render () {
		const { authentication } = this.props;

	const style = {
		'float': 'left',
		width: '48%',
		height: '100%',
	  margin: 10,
		padding: 10,
	  textAlign: 'center',
	  display: 'inline-block',
	};

    return (
			<div>
			{ authentication && !authentication.loggedIn &&
      <Paper zDepth={2} style={style} className="Signin">
        <h2>Sign In</h2>
        <form onSubmit={this.handleSignin}>
          <div>
            <TextField
              value={this.state.email}
              hintText='Email'
              type='text'
							id='email-field'
              onChange={this.changeEmail} />
          </div>
          <div>
            <TextField
              value={this.state.password}
              hintText='Password'
              type='password'
							id='password-field'
              minLength={8}
              onChange={this.changePassword} />
          </div>
          <div>
            <RaisedButton type='submit' disabled={this.state.disabled}>Sign In</RaisedButton>
          </div>
        </form>
      </Paper>}
		</div>
		)
  }
}


function mapStateToProps(state) {
//		console.log("Signin State: ", state)
		const { authentication } = state;
		return {
			authentication
		}
}
const connectedSignin = connect(mapStateToProps)(Signin);

export default connectedSignin;



// WEBPACK FOOTER //
// ./src/Signin.jsx